// Theme デフォルト値
export default {
  primary: "#0082AB",
  secondary: "#8133FF",
  error: "#FF5630",
  success: "#36B37E",
  warning: "#FFAB00",
};
